import { PRODUCTION } from "./constants";
import { checkEnvironment } from "./headerUtils";

export const hasAccessDuringMaintenance = (activeEmail: any) => {
  // STG or Release
  const arrayOfUsersForTesting: string[] = [
    "glozzia@itx.com",
    "israer@itx.com",
    "evicario@itx.com",
    "egranados@itx.com",
    "apochettino@itx.com",
    "asuiteqa@itx.com",
    "nmendez@itx.com",
    "rvillasana@itx.com",
  ];

  // for Production
  const arrayOfUsers: string[] = [
    "glozzia@itx.com",
    "israer@itx.com",
    "evicario@itx.com",
    "egranados@itx.com",
    "apochettino@itx.com",
    "asuiteqa@itx.com",
    "nmendez@itx.com",
    "alejandrot@itx.com",
    "vatencio@itx.com",
  ];

  if (
    process.env.REACT_APP_MAINTENANCE === "false" ||
    (activeEmail &&
      ((checkEnvironment() !== PRODUCTION &&
        arrayOfUsersForTesting.indexOf(activeEmail.toLowerCase()) > -1) ||
        (checkEnvironment() === PRODUCTION &&
          arrayOfUsers.indexOf(activeEmail.toLowerCase()) > -1)))
  ) {
    return true;
  }
  return false;
};
